import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-054db706")

_pushScopeId("data-v-054db706")
const _hoisted_1 = { class: "bg-ff personal" }
const _hoisted_2 = { class: "flex-1 text-center w-500" }
const _hoisted_3 = { class: "flex-1 text-center c-30" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.personalInfo, (item, index) => {
      return (_openBlock(), _createBlock("div", {
        class: ["flex list", { 'bg-f2': index % 2 == 0 }],
        key: item.key
      }, [
        _createVNode("p", _hoisted_2, _toDisplayString(item.name), 1),
        _createVNode("p", _hoisted_3, _toDisplayString(_ctx.personalData[item.key]), 1)
      ], 2))
    }), 128))
  ]))
})